<div class="product-single" [ngClass]="{ badges: hasBadge, normal: !wide, wide: wide }">
  <a>
    @if (hasBadge) {
      <div class="flag">
        @for (badge of product | badges: 'flag' : excludeBadges; track badge) {
          <em [class]="badge.badgeType">
            {{ badge.value ? '-' + badge.value + '%' : null }}
          </em>
        }
      </div>
    }
    <dl [class]="i18n.language">
      <dt
        [ngClass]="{ 'out-of-stock': product.productStatus === PRODUCT_STATUS.OUT_OF_STOCK }"
        (click)="onSelectProduct(product)"
      >
        <mat-checkbox
          class="checkbox"
          [checked]="isChecked"
          (change)="onSelectProduct(product)"
          (click)="onSelectProduct(product)"
        ></mat-checkbox>
        @if (numberTag) {
          <span class="text-number">{{ numberTag }}</span>
        }
        <img src="{{ product.images[0]?.endpoint }}" />
        @if (isRestockAlertUiEnabled && shouldShowRestockButton()) {
          <button
            type="button"
            class="button-restock-alert"
            [class.is-subscribed]="isRestockSubscribed()"
            [attr.aria-label]="isRestockSubscribed() ? 'Restock Notification ON' : 'Restock Notification OFF'"
            (click)="subscribeRestockAlert($event)"
          >
            <svg
              class="button-restock-alert__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                class="button-restock-alert__bell--off"
                d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
              />
              <path
                class="button-restock-alert__bell--on"
                d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
              />
            </svg>
            <span class="button-restock-alert__label">{{ isRestockSubscribed() ? 'Restock Notification ON' : 'Restock Notification OFF' }}</span>
          </button>
        }

      </dt>
      <dd (click)="goToProductDetail()">
        <p>[{{ product.brand.englishName }}]</p>
        <p>{{ product.englishName }}</p>
        @if ((product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg) {
          <div class="review-rating">
            <div style="align-items: center; z-index: 1">
              <ngx-stars
                [readonly]="true"
                [size]="1"
                [maxStars]="5"
                [initialStars]="(product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg"
                [color]="'#e04fa3'"
              >
              </ngx-stars>
              <!-- <span style="font-weight: bold; font-size: 20px">Rating is {{ ratingDisplay }} out of 5</span> -->
            </div>
            <div style="display: flex; align-items: center">
              <span class="rating-total">{{
                (product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg | number: '1.2-2'
              }}</span>
              <span class="review-count">
                ({{ (product?.mapperSaleProducts)[0].productOption.reviewDetails?.reviewCount | number }})</span
              >
            </div>
          </div>
        }
        <p>
          @if (!(product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
            <em>
              ${{
                product.minSalePriceUSD !== product.maxSalePriceUSD
                  ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minSalePriceUSD | currency: 'USD' : '' : '0.2')
              }}<span>{{
                product.minSupplyRate !== product.maxSupplyRate
                  ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                  : (product.minSupplyRate | salesRate) + '%'
              }}</span>
            </em>
            @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
              <del
                >MSRP ${{
                  product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                    ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                    : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                }}</del
              >
            }
            @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
              <del>
                MSRP ${{
                  product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                    ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                    : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                }}
              </del>
            }
          }
          @if ((product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
            <p class="price-area" style="margin-top: 2px">
              <em>
                ${{
                  product.minFinalSaleSupplyPriceUSD !== product.maxFinalSaleSupplyPriceUSD
                    ? (product.minFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                    : (product.maxFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2')
                }}
                <!-- <span [class.hide]="classes.best && !classes.badges">{{ -->
                <span>{{
                  product.minFinalSaleSupplyRate !== product.maxFinalSaleSupplyRate
                    ? (product.minFinalSaleSupplyRate | salesRate) +
                      '%~' +
                      (product.maxFinalSaleSupplyRate | salesRate) +
                      '%'
                    : (product.minFinalSaleSupplyRate | salesRate) + '%'
                }}</span>
              </em>
            </p>
            <div class="final-price">
              <div style="display: flex; align-items: center">
                <!-- <del [class.hide]="classes.best && !classes.badges" -->
                @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
                  <del
                    >MSRP ${{
                      product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                        ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                        : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                    }}</del
                  >
                }
                @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
                  <del>
                    MSRP ${{
                      product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                        ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                        : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                    }}
                  </del>
                }
              </div>
              <div style="display: flex; align-items: center; padding-left: 3px">
                <del style="color: #232323 !important">
                  ${{
                    product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                      ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                      : (product.maxSalePriceUSD | currency: 'USD' : '' : '0.2')
                  }}
                  <del style="color: #e04fa3 !important">
                    {{
                      product.minSupplyRate !== product.maxSupplyRate
                        ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                        : (product.minSupplyRate | salesRate) + '%'
                    }}
                  </del>
                </del>
              </div>
            </div>
          }
        </p>
        <app-product-stock-badges [product]="product" />
        <!-- <div class="badge" *ngIf="hasBadge">
            <ng-container *ngFor="let badge of product | badges: 'badge':excludeBadges">
              <span [class]="badge.badgeType">{{ badge.badgeType | commonCode: 'BADGE_TYPE' }}</span>
            </ng-container>
          </div> -->
      </dd>
    </dl>
  </a>
  @if (product.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK) {
    <a (click)="addToCartModal()" class="button-cart"></a>
  }
</div>
